// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `input,
select {
  width: 100% !important;
}

.card {
  border: 0 !important;
  overflow: hidden;
}

.card-container {
  overflow: hidden;
}

.card-body {
  overflow-y: scroll;
  padding: 10px !important;
}

.card-header {
  background: transparent;
  border: none;
}

.text-danger {
  height: 8px;
  padding-top: 4px;
  font-family: Inter;
  font-style: normal;
  font-size: 12px;
  letter-spacing: -0.0686271px;
}

.no-error-input {
  margin-bottom: 12px;
}

.card-header,
.card-footer {
  border: 0;
  background: white;
}

.custom-checkbox {
  padding-top: 5px;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
